import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=412995ae&scoped=true&"
import script from "./list-item.vue?vue&type=script&lang=ts&"
export * from "./list-item.vue?vue&type=script&lang=ts&"
import style0 from "./list-item.vue?vue&type=style&index=0&id=412995ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412995ae",
  null
  
)

export default component.exports